import customEventBus from "@common/scripts/libs/eventBus";
import api from "@common/utils/api";
import { useTranslation } from 'react-i18next';
import React, { useState } from "react";
import GiftCardPurchaseModal from "../product/GiftCardPurchaseModal";
const EditWishlistGiftCard = (props) => {
    const { t } = useTranslation();
    const [giftCardPurchase, setGiftCardPurchase] = useState(false);
    const addToBag = (fromKeyboard = false, card) => {
        // props.onAddStart && props.onAddStart();
        // if (!props.size) {
        //   console.log('no size, triggering size selector:', props.triggerOpenSize);
        //   setShowSizeBtn(true);
        //   props.triggerOpenSize && props.triggerOpenSize();
        //   return;
        // }
        const productId = `${props.product.id}`;
        api.moveFromWishlistToCart(props.product.listitemid, props.type, card).then((data) => {
            if (data.error) {
                props.updateErrorMessage && props.updateErrorMessage(data.message);
            }
            else {
                if (data.quantityTotal) {
                    const header = document.querySelector('header');
                    const firstRefine = document.querySelector('.listing-container .refine');
                    header.style.removeProperty('transform');
                    if (firstRefine) {
                        firstRefine.style.removeProperty('transform');
                    }
                    customEventBus.emit('bag:update', { fromMinicart: true });
                    customEventBus.emit('minicart:update', { fromAddToBag: props.wishlist.items.length > 1, fromKeyboard, pid: productId });
                }
                if (props.pushAnalytics) {
                    props.pushAnalytics();
                }
                // sposto qui la callback, in modo che viene eseguita come ultima operazione se la chiamata va a buon fine
                if (props.callback) {
                    props.callback();
                }
            }
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'selector-size', onClick: () => setGiftCardPurchase(true) },
            React.createElement("button", { className: 'selector__button' },
                React.createElement("span", null, t('gc.edit')))),
        React.createElement(GiftCardPurchaseModal, { isOpen: giftCardPurchase, onRequestClose: () => setGiftCardPurchase(false), type: 'edit', onMoveToBag: card => addToBag(false, card), 
            //@ts-ignore
            product: props.product, onSubmit: (card, formDef) => props.updateGiftCard(card, formDef) })));
};
export default EditWishlistGiftCard;
